import { FormIngredient, } from '../index';

export function AddForm(props) {
  
  return (
    <FormIngredient 
      filtrMassiv={props.filtrMassiv}
      lib={props.lib}
      handleAutoText={props.handleAutoText}
      hidden={props.hidden}
      handleDelete={props.handleDelete}
      mainMeasure={props.mainMeasure}
      handleChangeMinerals={props.handleChangeMinerals}
      vitam={props.vitam} 
      fields={props.fields}
      handleExcept={props.handleExcept}
      seasons = {props.seasons}
      handleClickPacking={props.handleClickPacking}
      ingredient={props.ingredient}
      choiceIngredient={props.choiceIngredient}
      onClose={props.onClose}
      handleChangeSelect={props.handleChangeSelect}
      onSubmit={props.onSubmit}
      isOpen={props.isOpen}
      onChange={props.onChange}
      ratioMeasure={props.ratioMeasure}
      name={props.name}
      values={props.values}
      price={props.price}
      measureprice = {props.measureprice}
      weightprice = {props.weightprice}
      category={props.category}
      calories={props.calories}
      protein={props.protein}
      fats={props.fats}
      carb={props.carb}
      digest={props.digest}
      title={props.title}
      nameError={props.nameError}
      submitDisabled={props.submitDisabled}
      handleChangeInput={props.handleChangeInput}
      vitamins={props.vitamins}
   />
  )
}
  